import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";

// @material-ui/icons
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import moment from "moment";

import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";
import MenuTypeTimetableContainer from "container/componentsCustom/MenuTypeTimetableContainer.js";
import Item from "componentsCustom/ListItem/Item";
import ItemTicketType from "componentsCustom/ListItem/ItemTicketType";
import { Link, useHistory, useParams } from "react-router-dom";
// import pathSplit from "util/pathSplit";
import getTicketsType from "api/getTicketsType";

import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import LeftSideEventInfo from "../componentsCustom/EventList/LeftSideEventInfo";
import styles from "./EventList.module.css";
import NavBarEvent from "../componentsCustom/EventList/NavBarEvent";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Hidden /*, Typography */ } from "@material-ui/core";
import DateTimeInputSection from "../componentsCustom/EventList/DateTimeInputSection";
import Button from "../components/CustomButtons/Button";

import getEventi from "api/getEventi";

const useStyles = makeStyles(menuStyle);

export default function BaseEventList(props) {
  const {
    updateCart,
    cart,
    language,
    museum,
    currency,
    customStyle,
    cartParams,
    articles,
    updateEventSelected,
    eventSelected,
  } = props;

  const history = useHistory();

  const { home } = useParams();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const [list, setList] = useState([]);
  const [, setCategories] = useState([]);

  // eslint-disable-next-line
  const [showAddItem, setShowAddItem] = useState(false);
  // eslint-disable-next-line
  const [selectItem, setSelectedItem] = useState({});
  // const [showAlert, setShowAlert] = useState(true);
  const [ticketsType, setTicketsType] = useState([]);
  const [openings, setOpenings] = useState({});
  const [dateTimeSelected, setDateTimeSelected] = useState(null);
  const [availablePlaces, setAvailablePlaces] = useState(null);
  const [showPlacesWarning, setShowPlacesWarning] = useState(false);
  const [showCartFullWarning, setShowCartFullWarning] = useState(false);
  const [isOpen] = useState("");

  //Check if event details have been pulled
  const [loader, setLoader] = useState(true);

  //Bool used to check if there's only one day left for a repetead event
  const [isLastDay, setIsLastDay] = useState(false);

  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    if (articles && articles[0] && articles.length > 0) {
      const categoriesArray = articles.map((el) => {
        return {
          codici_sconto: el.codici_sconto,
          id: el.id,
          nome_categoria: el.nome_categoria,
        };
      });

      setList(articles);
      setCategories(categoriesArray);
    }
  }, [articles]);

  useEffect(() => {
    if (Object.keys(eventSelected).length === 0) {
      // get event by id
      if (museum && museum.organisation && museum.organisation.id) {
        getEventi(museum.organisation.id)
          .then((response) => {
            const url = window.location.href.toString();
            const urlDivided = url.split("/");
            let idToFind = "";
            if (urlDivided && urlDivided.length > 0) {
              idToFind = urlDivided[urlDivided.length - 1];
              const elementToFind = response.find(
                (el) => el.id.toString() === idToFind
              );
              if (elementToFind) {
                updateEventSelected(elementToFind);
              } else {
                history.replace(`../shop/${home}`);
              }
            } else {
              history.replace(`../shop/${home}`);
            }
          })
          .catch((err) => {
            history.replace(`../shop/${home}`);
          });
      }
      //se l'evento non è presente torno alla lista eventi
      //history.replace(`../shop`);
    }

    if (eventSelected && eventSelected.ora_inizio && eventSelected.ora_fine) {
      var check = false;
      var start = eventSelected.ora_inizio;

      eventSelected.eventi_child.forEach((event) => {
        if (new Date() <= new Date(event.ora_fine) && !check) {
          start = event.ora_inizio;
          check = true;
        }
      });

      if (moment(start).isSame(eventSelected.ora_fine, "day")) {
        setIsLastDay(true);
        setDateTimeSelected(start);
      }

      setOpenings({
        ora_inizio: start,
        ora_fine: eventSelected.ora_fine,
      });
    }
    if (eventSelected && eventSelected.id) {
      //console.log("Sono qui", eventSelected.eventi_child.length);
      if (eventSelected.eventi_child.length === 1) {
        setDateTimeSelected(eventSelected.eventi_child[0].ora_inizio);
      }
      getTicketsType(eventSelected.id).then((response) => {
        if (response && response.length > 0) {
          setTicketsType(response);
        }
      });
    }

    if (eventSelected) {
      setLoader(false);
    }
  }, [eventSelected, museum, history, updateEventSelected, home]);

  useEffect(() => {
    setShowPlacesWarning(false);
    if (dateTimeSelected) {
      let tempDate = new Date(dateTimeSelected);
      let nowOffset = new Date().getTimezoneOffset();
      let selOffset = tempDate.getTimezoneOffset();

      // if the selection timezone offset is different from today selection timezone
      // use a selection date with an hour variation
      let diff = -(selOffset - nowOffset) / 60;
      tempDate.setHours(tempDate.getHours() + diff);

      setAvailablePlaces(
        eventSelected.eventi_child.find((e) =>
          moment(e.ora_inizio).isSame(
            selOffset !== nowOffset ? tempDate : dateTimeSelected
          )
        ).posti_disponibili
      );
    }
  }, [dateTimeSelected, eventSelected]);

  const classes = useStyles();

  const { t } = useTranslation();

  function openSweetAlert(item, category, index, timetable) {
    setShowAddItem(true);
    setSelectedItem(
      Object.assign({}, item, { category: category, index, timetable })
    );
  }

  function addToCart(item, quantity, ingredientC, additionalKey, note, hg) {
    // AGGIUNGI A CARRELLO

    if (item && item.id) {
      if (cart && Array.isArray(cart)) {
        const copyCart = [].concat(cart);

        /* ***********************************************************
        POSSO CALCOLARE L'ID DELLE AGGIUNTE ANDANDO A DIVIDERE ADDITIONALKEY
        ADDITIONALKEY È COMPOSTO DA -->
        $(HG)${TYPE}_${ID_AGGIUNTA}_${ID_ITEM_AGGIUNTA}(${QUANTITY})/...
        ********************************************************** */
        let maxObj = {};
        let maxNumber = 0;
        const allAdd = additionalKey.split("/");

        allAdd.forEach((element) => {
          const [, id] = element.split("_");
          const findEl =
            item && item.add && item.add.find((el) => el._id === id);

          if (findEl && findEl.maxNumber) {
            maxNumber = findEl.maxNumber;
            maxObj = Object.assign({}, maxObj, { [id]: maxNumber });
          }
        });

        if (copyCart && copyCart.length > 0) {
          // CERCO SE QUEL BIGLIETTO è GIA' PRESENTE NEL CARRELLO ed è riferito alla stessa data
          // CONTROLLO ANCHE SE AL BIGLIETTO SONO STATE FATTE DELLE MODIFICHE
          // QUESTA FUNZIONE PER LE MODIFICHE ATTUALMENTE NON VIENE USATA

          const findIndexEl = cart.findIndex((el) => {
            return (
              el.productId === item.id &&
              moment(el.dateTimeSelected).isSame(dateTimeSelected)
            );
          });

          if (findIndexEl >= 0) {
            // SE IL BIGLIETTO ESISTE GIA'

            // SE IL BIGLIETTO ESISTE GIA' AUMENTO LA QUANTITA'
            copyCart[findIndexEl].quantity += quantity || 1;
          } else {
            // SE IL BIGLIETTO NON ESISTE LO METTO NEL CARRELLO
            copyCart.push({
              dateTimeSelected: dateTimeSelected,
              item: item,
              quantity: quantity,
              price: !Number.isNaN(Number(item.prezzo))
                ? Number(item.prezzo)
                : 0.0,
              productId: item.id,
              ingredientC,
              additionalKey,
              note,
              categoria_articolo: item.categoria_articolo,
              index: item.index,
              information: item.information || [],
            });
          }
        } else {
          copyCart.push({
            dateTimeSelected: dateTimeSelected,
            item: item,
            quantity: quantity,
            price: !Number.isNaN(Number(item.prezzo))
              ? Number(item.prezzo)
              : 0.0,
            productId: item.id,
            ingredientC,
            additionalKey,
            note,
            categoria_articolo: item.categoria_articolo,
            index: item.index,
            information: [
              /* *****************************************
               IN QUESTO ARRAY VERRANNO SCRITTE LE INFORMAZIONI DI TUTTI I VISITATORI
               ***************************************** */
              // visitatore: {
              //   CAP: "",
              //   nazione: "",
              //   sesso: "",
              //   nascita: null,
              //   codice_biglietto: item.ticketId,
              //   flag_data_aperta: false,
              //   email: shippingInfo.email
              // },
            ],
          });
        }
        updateCart(copyCart);
      }
    }
  }

  const {
    cartCounter,
    totToShow, // totalPrice + servicesFees + deliveryCost
  } = cartParams;

  const componentsContent = (
    <CardBody style={{ marginBottom: "50px" }}>
      {ticketsType && ticketsType.length > 0 ? (
        <div>
          {showPlacesWarning && (
            <p style={{ fontWeight: 700, color: "darkred" }}>
              {t("only")} {availablePlaces}{" "}
              {availablePlaces === 1 ? t("oneLeft") : t("fewLeft")}
            </p>
          )}
          <GridContainer>
            {ticketsType.map((ticket, ind) => {
              return (
                <ItemTicketType
                  key={ticket.id}
                  item={ticket}
                  currency={currency}
                  language={language}
                  customStyle={customStyle}
                  index={ind}
                  openSweetAlert={openSweetAlert}
                  addToCart={addToCart}
                  updateCart={updateCart}
                  cart={cart}
                  availablePlaces={availablePlaces}
                  setShowPlacesWarning={setShowPlacesWarning}
                  dateTimeSelected={dateTimeSelected}
                  eventSelected={eventSelected}
                  isEvent={true}
                />
              );
            })}
          </GridContainer>
        </div>
      ) : list && Object.keys(list) && Object.keys(list).length > 0 ? (
        <div>
          <MenuTypeTimetableContainer />
          {list.map((category) => {
            return (
              <div key={category.id}>
                <div
                  style={
                    matches && museum.delivery && museum.delivery.isListMenu
                      ? {
                          border: "solid 1px rgba(222,222,222,1)",
                          borderRadius: 10,
                          display: "table",
                          padding: "5px",
                          paddingBottom: "10px",
                          marginTop: "5px",
                          marginBottom: "5px",
                          width: "100%",
                        }
                      : {}
                  }
                >
                  <h1
                    className={classes.title}
                    style={{ float: "left", width: "calc(100% - 30px)" }}
                  >
                    {category.nome_categoria ? category.nome_categoria : ""}
                  </h1>
                  {matches && museum.delivery && museum.delivery.isListMenu ? (
                    <div
                      style={{
                        width: "30px",
                        textAlign: "center",
                        marginTop: "10px",
                        float: "left",
                      }}
                    >
                      {category &&
                      category.categoria_articolo &&
                      category.categoria_articolo._id === isOpen ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </div>
                  ) : null}
                </div>

                <GridContainer>
                  {category.articoli
                    ? category.articoli.map((item, ind) => {
                        return (
                          <Item
                            key={item.id}
                            item={item}
                            currency={currency}
                            language={language}
                            customStyle={customStyle}
                            category={category}
                            index={ind}
                            openSweetAlert={openSweetAlert}
                            addToCart={addToCart}
                            updateCart={updateCart}
                            cart={cart}
                            availablePlaces={availablePlaces}
                            setShowPlacesWarning={setShowPlacesWarning}
                            dateTimeSelected={dateTimeSelected}
                            eventSelected={eventSelected}
                          />
                        );
                      })
                    : null}
                </GridContainer>
              </div>
            );
          })}
        </div>
      ) : null}
    </CardBody>
  );

  function checkCartQuantity(cartToCheck) {
    var totQuantity = 0;
    if (cartToCheck.length !== 0) {
      cartToCheck.forEach((element) => {
        totQuantity += element.quantity;
      });
    }
    if (totQuantity <= 7) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (!checkCartQuantity(cart)) {
      setShowCartFullWarning(true);
    } else {
      setShowCartFullWarning(false);
    }
    // eslint-disable-next-line
  }, [cart]);

  return (
    <div
      style={{
        backgroundColor: museum?.customizations?.eventDetailsBgColor
          ? museum?.customizations?.eventDetailsBgColor
          : "#ffffff",
      }}
    >
      <style>
        {`.MuiPickersToolbar-toolbar, .MuiPickersDay-daySelected {
          background-color: ${
            eventSelected?.colore ? eventSelected?.colore : "#000000"
          } !important
        }`}
      </style>
      <MobileWrapper
        type={"contacts"}
        showButtons={!!(cartCounter && cartCounter > 0)}
        containerClasses={classes.eventListContainer}
        containerMobileButton={classes.containerMobileButtonMenu}
        buttons={[
          {
            onClick: () => {},
            color: "warning",
            text: t("cart.go_to_cart"),
            isActive: true,
            isLinkActive: true,
            path: `../../contacts/${home}`,
            customStyle: { backgroundColor: customStyle.buttonCart },
            leftComponent: (
              <>
                {cartCounter ? (
                  <span style={{ verticalAlign: "super" }}>
                    <span className={classes.notifications}>
                      <span>{cartCounter}</span>
                    </span>
                  </span>
                ) : null}
              </>
            ),
            rightComponent: (
              <span className={classes.littlePrice}>
                {totToShow ? totToShow.toFixed(2) : ""}
                <span style={{ paddingRight: "2px", color: "white" }}>
                  {totToShow && currency && currency.symbol
                    ? currency.symbol
                    : ""}
                </span>
              </span>
            ),
          },
        ]}
      >
        {loader ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              position: "absolute",
              overflow: "hidden",
            }}
          >
            <ReactLoading
              type={"spinningBubbles"}
              color={
                museum?.customizations?.eventDetailsBgColor
                  ? museum?.customizations?.eventDetailsBgColor
                  : "#000000"
              }
              height={50}
              width={50}
            />
          </div>
        ) : (
          <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
            <NavBarEvent
              logoUrl={museum?.logo_light?.url}
              bgColor={museum?.customizations?.eventInfoBgColor}
            />
            {
              <div
                // href="/list"
                // to={`/${museum.identificativo}/shop/`}
                style={{
                  width: "100%",
                  backgroundImage: `url(${eventSelected.immagine_evento?.url ||
                    museum.cover?.url})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  minHeight: "300px",
                  display: "flex",
                  //alignItems: "center",
                  padding: "30px",
                  flexDirection: "column",
                  // justifyContent: "end",
                  //textShadow: "3px 2px 15px rgba(0,0,0,0.8)",
                  textAlign: "left",
                  //marginTop: "100px"
                }}
              >
                <Link
                  to={`/${museum.identificativo}/shop/${home}`}
                  className={styles.backToMuseum}
                  style={{
                    color: "#ffffff",
                    fontSize: "15px",
                    width: 40,
                    height: 40,
                    fontWeight: 600,
                    backgroundColor: "rgb(0,0,0,.5)",
                    borderRadius: 40,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ArrowBackIcon />
                  {/*<span>{t("backToList")}</span>*/}
                </Link>
              </div>
            }

            <div
              className={styles.contentContainer}
              style={{ height: windowSize.innerWidth > 800 ? "100%" : "" }}
            >
              <LeftSideEventInfo eventInfo={eventSelected} />
              {eventSelected.prenotabile ? (
                <div
                  className={styles.ticketListContainer}
                  style={{
                    color: museum?.customizations?.eventDetailsTextColor
                      ? museum?.customizations?.eventDetailsTextColor
                      : "#000000",
                  }}
                >
                  {eventSelected?.eventi_child?.length > 1 && !isLastDay && (
                    <DateTimeInputSection
                      openings={openings}
                      onChangeDateTime={(dateTime) => {
                        setDateTimeSelected(dateTime);
                      }}
                      events={eventSelected.eventi_child}
                    />
                  )}
                  {dateTimeSelected && availablePlaces !== null && (
                    <>
                      {availablePlaces > 0 ? (
                        componentsContent
                      ) : (
                        <div>
                          <h3 style={{ fontWeight: 700 }}>
                            {t("placesCompleted")}
                          </h3>
                          <p>
                            {t("allPlaces")} <b>{eventSelected.nome_evento}</b>{" "}
                            {t("of")}{" "}
                            <b>
                              {moment(dateTimeSelected).format("DD MMM YYYY")}
                            </b>{" "}
                            {t("areCompleted")}
                            {eventSelected.eventi_child.filter(
                              (e) => moment(e.ora_inizio) >= moment()
                            ).length > 1 && (
                              <p>
                                {t("areStillAvailable")}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    marginTop: 10,
                                  }}
                                >
                                  {eventSelected.eventi_child
                                    .filter(
                                      (e) =>
                                        e.posti_disponibili > 0 &&
                                        moment(e.ora_inizio) >= moment()
                                    )
                                    .map((event, index) => {
                                      return (
                                        <div
                                          key={`event_selected_child_${index.toString()}`}
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            width: "20%",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <p>
                                            {moment(event.ora_inizio).format(
                                              "DD MMM YYYY"
                                            )}
                                          </p>
                                          <p>
                                            {event.posti_disponibili}{" "}
                                            {event.posti_disponibili === 1
                                              ? t("oneLeft")
                                              : t("fewLeft")}
                                          </p>
                                        </div>
                                      );
                                    })}
                                </div>
                              </p>
                            )}
                          </p>
                        </div>
                      )}

                      {showCartFullWarning && (
                        <p style={{ fontWeight: 700, color: "darkred" }}>
                          {t("cartFull")}
                        </p>
                      )}

                      {cart?.length > 0 && (
                        <Hidden smDown implementation="css">
                          <div className={styles.checkoutButtonContainer}>
                            <Button
                              round={false}
                              size="sm"
                              color="lightBlue"
                              className={classes.buttonBig}
                              style={{
                                backgroundColor: customStyle.buttonAction,
                                maxWidth: "400px",
                                marginBottom: 100,
                                marginTop: 40,
                              }}
                              // color="info"
                              onClick={() =>
                                history.push(
                                  `/${museum.identificativo}/contacts/${home}`
                                )
                              }
                            >
                              <span className={classes.buttonBigText}>
                                {t("cart.checkout")}
                              </span>
                            </Button>
                          </div>
                        </Hidden>
                      )}
                    </>
                  )}
                  {/* <div className="logo_emma">
                  <img src={logo} alt="logo" />
                </div> */}
                </div>
              ) : (
                <div
                  className={styles.ticketListContainer}
                  style={{
                    color: museum?.customizations?.eventDetailsTextColor
                      ? museum?.customizations?.eventDetailsTextColor
                      : "#000000",
                  }}
                >
                  <h3 style={{ fontWeight: 700 }}>{t("eventClosed")}</h3>
                </div>
              )}
            </div>
          </div>
        )}
      </MobileWrapper>
    </div>
  );
}

BaseEventList.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  articles: PropTypes.arrayOf(PropTypes.object).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    timetable: PropTypes.object,
  }).isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  updateCartParams: PropTypes.func.isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number,
    vat: PropTypes.number,
  }).isRequired,
  updateCart: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  cart: PropTypes.arrayOf(PropTypes.object),
  museum: PropTypes.object,
  customStyle: PropTypes.object,
  eventSelected: PropTypes.object,
  updateEventSelected: PropTypes.func,
};

BaseEventList.defaultProps = {
  museum: null,
  customStyle: {},
  eventSelected: null,
};
